import { Activity, CircleAlert, Variable, type LucideIcon } from 'lucide-react';
import { strings } from '../strings';
import type { DockZone, WindowDefaults } from './layout';

/** A tool window (spec 6.8.1). Its content comes from the page through `ToolWindowContent`. */
export interface ToolWindowDefinition {
  id: string;
  title: string;
  icon: LucideIcon;
  /** The digit of its Ctrl+Shift shortcut. */
  shortcut: number;
  defaultZone: DockZone;
  defaultVisible: boolean;
  /** Active tab of its zone in the default layout. */
  defaultActive?: boolean;
  /** Why it isn't available on a page that provides no content. */
  unavailable: string;
}

/** The tool windows, in status-bar order (spec 6.8.1). */
export const TOOL_WINDOWS: readonly ToolWindowDefinition[] = [
  {
    id: 'variables',
    title: strings.variables.title,
    icon: Variable,
    shortcut: 1,
    defaultZone: 'bottom',
    defaultVisible: true,
    defaultActive: true,
    unavailable: strings.variables.unavailable,
  },
  {
    id: 'problems',
    title: strings.dock.windows.problems,
    icon: CircleAlert,
    shortcut: 2,
    defaultZone: 'bottom',
    defaultVisible: true,
    unavailable: strings.dock.unavailable.problems,
  },
  {
    id: 'activity',
    title: strings.dock.windows.activity,
    icon: Activity,
    shortcut: 3,
    defaultZone: 'bottom',
    defaultVisible: false,
    unavailable: strings.dock.unavailable.activity,
  },
];

export function windowDefaults(definitions: readonly ToolWindowDefinition[]): WindowDefaults[] {
  return definitions.map((d) => ({
    id: d.id,
    zone: d.defaultZone,
    visible: d.defaultVisible,
    active: d.defaultActive,
  }));
}

/** What a window's content reports for its tab and status-bar button (spec 6.8.5). */
export interface ToolWindowBadge {
  errors?: number;
  warnings?: number;
  /** A run shown in the window is active. */
  live?: boolean;
}
